/* The restore affordance, extracted verbatim from components/ArchivePage.jsx.
   The agent settings version history renders it too, so it sits below both.
   ArchivePage re-exports it. */

import React from "react";
import { ArchiveRestore } from "lucide-react";

/* Shared restore affordance — also used by the agent settings version history.
   `reveal` hides it until the parent row (needs `group`) is hovered. */
export function RestoreButton({ onClick, title = "Restore", reveal = false, disabled = false }: {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  title?: string;
  reveal?: boolean;
  disabled?: boolean;
}) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`press shrink-0 ${reveal ? "opacity-0 group-hover:opacity-100 focus-visible:opacity-100" : ""} flex items-center gap-1.5 px-2.5 py-[5px] rounded-[8px] text-[12.5px] font-medium text-[var(--text-secondary)] bg-[var(--surface)] ring-1 ring-[var(--hairline-strong)] ${disabled ? "opacity-40 cursor-not-allowed" : "hover:text-[var(--text-primary)] hover:ring-[var(--hairline-focus)]"}`}
      title={title}
    >
      <ArchiveRestore className="w-3 h-3" strokeWidth={1.75} />
      Restore
    </button>
  );
}
